<template>
    <v-card style="border:0px solid pink;">
        <v-list class="ma-0 pa-2" style="border:0px solid green;" >
            <v-subheader class="title" >Sites</v-subheader>

            <!-- <v-btn color="primary" small @click="collapseAll">Collapse All</v-btn> -->

            <v-icon style="float:right" large color="green darken-2" @click="onRefresh">mdi-refresh</v-icon>

            <v-data-table ref="expandableTable" :headers="headers" :items="data" hide-default-footer item-key="equipment_name" :single-expand=true :items-per-page="items_per_page" sort-by="site" group-by="site">

            <template v-slot:item="props">
                    <tr @click="onEquipmentClick(props.item.siteref, props.item.equipref)">
                      <td style="width: 30%;border: 0px solid blue;">
                          <v-icon style="float:right;" >mdi-arrow-right-thick</v-icon>
                      </td>
                      <td align="left">
                        <span>{{ props.item.equipment_name }}</span>
                      </td>
                      <td>
                        {{ props.item.status }}
                      </td>
                    </tr>
             </template>

            <!-- eslint-disable-next-line -->
            <template v-slot:group.header="{ group, headers, toggle, isOpen }">
            <td :colspan="headers.length">
                <v-btn @click="toggle" x-small icon :ref="group">
                    <v-icon v-if="isOpen">mdi-plus</v-icon>
                    <v-icon v-else>mdi-minus</v-icon>
                </v-btn>
                <span @click="onSiteClick(group)" class="mx-5 font-weight-bold">{{ group }}</span>
            </td>
            </template>

          </v-data-table>
          
        </v-list>    
    </v-card>
</template>


<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IRefInfo, IRefLastValue } from '@/main';
import { DateTime } from "luxon";

@Component({
    components: {},
})
export default class Sites extends Vue {

    @Prop() public selectedSiteGroup!: string;

    public $refs!: {
        expandableTable: any;
    };

    private clockHandler: any;
    private points: Map<string, IRefInfo> = new Map();
    private last_values: Map<string, IRefLastValue> = new Map();
    private data: any[] = [];
    private items_per_page: number = -1;

    private headers = [
    {
      text: 'Equipment',
      align: 'left',
      sortable: true,
      value: 'equipment_name',
    },
    { text: 'Site', units: '', align: 'left', value: 'site' },
    // { text: 'Energy', units: '(kWh / m²  / year)', align: 'center', value: 'energy_12months' },
    // { text: 'Peak C0²', units: '(Average ℃)', align: 'center', value: 'peak_co2_12months' },
    // { text: 'Avg Downstairs Temp', units: '(Average ℃)', align: 'center', value: 'downstairs_temp_12months' },
    // { text: 'Avg Bedroom Temp', units: '(Average ℃)', align: 'center', value: 'upstairs_temp_12months' },
    // { text: ' ', units: ' ', align: 'center', value: '--' },
    // { text: 'Energy', units: '(kWh / m²  / year)', align: 'center', value: 'energy_30days' },
    // { text: 'Peak C0²', units: '(Average ℃)', align: 'center', value: 'peak_co2_30days' },
    // { text: 'Avg Downstairs Temp', units: '(Average ℃)', align: 'center', value: 'downstairs_temp_30days' },
    // { text: 'Avg Bedroom Temp', units: '(Average ℃)', align: 'center', value: 'upstairs_temp_30days' },
  ];


    public async created() {
        this.page_load();
    }

    public async onRefresh() {
        this.page_load();
    }

    public async page_load() {

        const self = this;
        const payload = {carnego_site_group_ref: '@' + self.selectedSiteGroup};

        self.data = [];
        self.points = await self.$store.cache.dispatch('getRefsFromSiteGroupSitesAndNames', payload);
        self.last_values =  await self.$store.dispatch('requestLastValuesForSiteGroupRefMap', payload);

        const groupBy = (xs: IRefInfo[], key: string) => {
            return xs.reduce((rv, x) => {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
            };

        const points_grouped_by_equip = groupBy(Array.from(self.points.values()), 'equip_namespace');

        for (const equip_namespace of Object.keys(points_grouped_by_equip)) {
            const ref_infos: IRefInfo[] = points_grouped_by_equip[equip_namespace];

            self.data.push(
            {
                equipment_name: ref_infos[0].equip_namespace,
                site: ref_infos[0].site_namespace,
                siteref: ref_infos[0].site_ref,
                equipref: ref_infos[0].equip_ref,
                status: self.get_status(ref_infos[0].equip_ref),
            });
        }

        // self.collapseAll();

    }

    public async mounted() {

        const self = this;

        // Vue.nextTick( () => {
        //     self.collapseAll();
        //     self.collapseAll();
        // });

        setTimeout(() => self.collapseAll(), 500);

        return;
    }

    private get_status(equip_ref: string) {

        const self = this;

        const point_refs = Array.from(self.points.values()).filter(
            (v) => v.carnego_site_group_ref === '@' + self.selectedSiteGroup && v.equip_ref === equip_ref).map((i) => [i.ref, i.namespace]);

        console.log([...point_refs]);

        let status = '✅';

        for (const [reference, namespace] of point_refs) {

            debugger;

            const r = self.last_values.get(reference);

            if (r === undefined) {
                console.log('No point reference in last values: ' + reference + ' ' + namespace);
                status =  '❌';
                break;
                // continue;
            }

            const duration =  DateTime.now().diff(r.timestamp).minutes;

            if (duration >= 10) {
                console.log('Point value older than 10 minutes: ' + reference + ' ' + namespace);
                status =  '❌';
                break;
            }
        }

        return status;
    }

    private expandAll() {
        const self = this;

        for (const name of Object.keys(self.$refs.expandableTable.openCache)) {
            self.$refs.expandableTable.openCache[name] = true;
        }
    }

    private collapseAll() {

        const self = this;

        for (const name of Object.keys(self.$refs.expandableTable.openCache)) {
            self.$refs.expandableTable.openCache[name] = false;
        }
    }

    private onEquipmentClick(siteref: string, equipref: string) {
        this.$emit('equipmentClicked', [siteref, equipref]);
    }

    private onSiteClick(ref: string) {
        this.$emit('siteClicked', ref);
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>

